import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps } from "react-router-dom";
import { toast } from "react-toastify";
import { observable } from "mobx";
import { drawSelects } from '../site/layout/common';

interface IndexLeadProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}
@observer
export default class IndexLead extends React.Component<IndexLeadProps> {
  @observable private leads: any;
  @observable private isLoaded = false;
  @observable private validationErrors: string[] = [];
  @observable private status = [
          { id: "PENDING", name: "Pendiente" },
          { id: "CONTACTED", name: "Contactado" },
          { id: "CONVERTED", name: "Convertido a cliente" },
          { id: "LOST", name: "Perdido" },
          { id: "UNREACHABLE", name: "No localizado" },
          { id: "ON_HOLD", name: "En espera" },
      ];

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }
  
  private setValidation = (value: boolean, name: string): void => {
    const error = this.validationErrors.indexOf(name);
    if (value && error === -1) {
        this.validationErrors.push(name);
    } else if (!value && error !== -1) {
        this.validationErrors.splice(error, 1);
    }
}

  init = () => {
    http
      .get("/api/leads/read")
      .then((response) => {
        this.leads = response.data.response;
        this.isLoaded = true;
      })
      .catch(() => {
        toast.error("Error cargando clientes potenciales");
      });
  };

  private handleChange = (event: any, id: string) => {
    const { name, value } = event.target;
    console.log(name, value);
    console.log(id);
    http
      .post(`/api/leads/update`, { ...this.leads[id], [name]: value })
        .then(() => {
            toast.success("Estatus actualizado");
            this.leads[id].status = value;
        })
        .catch(() => {
            toast.error("Error actualizando estatus");
        });
  };

render() {
    if (!this.isLoaded) {
      return null;
    }
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-primary">
                <h4 className="card-title ">Lista de clientes potenciales</h4>
                <p className="card-category">
                  Lista de clientes potenciales registrados
                </p>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead className=" text-primary">
                      <tr>
                        <th>Nombre</th>
                        <th>Teléfono</th>
                        <th>Estatus</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.leads.map((lead: any, index: any) => {
                        return (
                          <Fragment key={index}>
                            <tr>
                              <td>{lead.name}</td>
                              <td>{lead.phone}</td>
                              <td>
                              {drawSelects(this.status, (event: any) => this.handleChange(event, index), lead.status, "Estatus", "status")}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
